import * as React from 'react'
import { ActionIcon } from '@mantine/core'

// 社区行政村减灾能力
const SvgComponent = ({ width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 22 26"
    className="design-iconfont"
    width={width}
    height={height}
  >
    <defs>
      <linearGradient
        x1="50%"
        y1="0%"
        x2="50%"
        y2="98.993%"
        id="5hj4s5uxr__xc0nx13qnb"
      >
        <stop stopColor="#94D87B" offset="0%" />
        <stop stopColor="#67B85B" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="50%"
        y1="0%"
        x2="50%"
        y2="100%"
        id="5hj4s5uxr__vdgnmnos4a"
      >
        <stop stopColor="#B1E89D" offset="0%" />
        <stop stopColor="#92CD89" offset="100%" />
      </linearGradient>
      <filter
        x="-74.4%"
        y="-53.1%"
        width="248.7%"
        height="248.7%"
        filterUnits="objectBoundingBox"
        id="5hj4s5uxr__ssk4ytpczc"
      >
        <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation={2}
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0.415686275 0 0 0 0 0.729411765 0 0 0 0 0.364705882 0 0 0 1 0"
          in="shadowBlurOuter1"
        />
      </filter>
      <path
        d="M8.741.672H2.017c-.742 0-1.345.603-1.345 1.345v6.724c0 .743.603 1.345 1.345 1.345h6.724c.743 0 1.345-.602 1.345-1.345V2.017c0-.742-.602-1.345-1.345-1.345Zm-.407 4.604s-1.137.22-1.45.3c-.311.08-.69-.481-.802-.501-.067.18-.29.682-.403 1.022.445.046.873.197 1.248.442.045.16.513 1.945.513 1.945s.202.381-.379.522c-.58.14-.605-.281-.605-.281S6.052 7.36 6.01 7.28a2.162 2.162 0 0 0-.959-.18c-.178.04-.538 1.204-.914 1.284-.471.1-1.85-.662-1.85-.662a.47.47 0 1 1 .222-.902c.346.184.713.326 1.093.42.15-.221.263-.465.336-.722.115-.368.25-.73.404-1.083.09-.216.137-.448.134-.682a.281.281 0 0 0-.312.161c-.225.355-.47.697-.735 1.023-.379.462-1.047.04-.757-.403a5.079 5.079 0 0 1 1.362-1.5 4.02 4.02 0 0 1 2.018 0c.406.093.77.318 1.033.64a3.37 3.37 0 0 0 1.003-.18c.245-.1.524.016.624.26.157.424-.378.522-.378.522ZM6.724 2.69a.672.672 0 1 1-1.345 0 .672.672 0 0 1 1.345 0Z"
        id="5hj4s5uxr__ryz1whs5ld"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        d="M10.759 1a9.698 9.698 0 0 1 6.898 2.874 9.82 9.82 0 0 1 2.86 6.946c0 2.385-1.506 5.3-3.329 7.873C14.858 21.98 11.923 25 10.758 25c-1.164 0-4.098-3.019-6.43-6.307C2.507 16.12 1 13.205 1 10.82a9.82 9.82 0 0 1 2.86-6.946A9.698 9.698 0 0 1 10.76 1Z"
        stroke="url(#5hj4s5uxr__vdgnmnos4a)"
        strokeWidth={2}
        fill="url(#5hj4s5uxr__xc0nx13qnb)"
      />
      <g transform="translate(5.38 5.38)" fillRule="nonzero">
        <use
          fill="#000"
          filter="url(#5hj4s5uxr__ssk4ytpczc)"
          xlinkHref="#5hj4s5uxr__ryz1whs5ld"
        />
        <use fill="#ECF7E8" xlinkHref="#5hj4s5uxr__ryz1whs5ld" />
      </g>
    </g>
  </svg>
)

const Icon = (props) => {
  const {
    fill = '#0152D9',
    variant = 'transparent',
    size = 20,
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <SvgComponent width={width} height={height} color={fill} />
    </ActionIcon>
  )
}

export default Icon
